module.exports = __webpack_public_path__ + "static/media/Tropical-night.039d5278.svg";